// styles
import styled from 'styled-components';

const SoFormTitle = styled.h3`
  /* Stop title */

  width: 600px;
  height: 24px;

  /* 20px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height, or 120% */

  display: flex;
  align-items: center;

  /* grey / 700 */

  color: #54708c;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`;

export default SoFormTitle;
